import React from 'react';
import { Toast } from 'antd-mobile';

import CustomComponent from '../CustomComponent';

import { convertStyleData, transformPx2Rem } from '@utils/tools';
import util from '@utils/util';
import { appMethod as app } from '@utils/app';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './ListVesselCustomComponent.less';

const vesselCheckIfCount = (compData) => {
  // 标记是否有计数器组件
  let flag = false;
  let types = {
    'count-ele': true,
    'new-count': true,
  };
  const checkHasEle = (ele) => {
    // 已经标记为true
    if (flag) {
      return;
    }
    // 不为组件
    if (!ele.type) {
      return;
    }
    // 当前组件是否有寻找的组件，有则标记
    if (types[ele.type]) {
      flag = true;
      return;
    }
    // 判断当前组件不为最后一级
    if (Array.isArray(ele.content)) {
      for (let subEle of ele.content) {
        checkHasEle(subEle);
      }
    } else if (ele.type === 'layout-vessel') { // 双栏组件的content不为数组
      for (let attr of Object.keys(ele.content)) {
        for (let subEle of ele.content[attr]) {
          checkHasEle(subEle);
        }
      }
    }
  }
  checkHasEle(compData);
  if (flag) {
    return 1;
  }
  return 0;
}

export default class ListVesselCustomComponent extends React.Component {
  state = {
    listData: [],
    loading: false,
    loadingFail: false, // TODO
    page: 1,
    isMore: 0,
  }
  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance, isPullRefresh) => {
    let that = this;
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let url = '/index.php?r=AppData/getFormDataList';

    let param = {
      id: customFeature['id'],
      form: customFeature['form'],
      page: 1,
      app_id: app.getAppId(),
      is_count: vesselCheckIfCount(compData),
    };
    pageInstance.setData({
      ['eles[' + compindex + '].param']: param
    });

    if (!param['form']) {
      Toast.info('动态列表未绑定数据对象');
      return;
    }
    if(customFeature.form=='group_buy'){
      url="/index.php?r=AppGroupBuy/GetGroupBuyGoodsList";
      param.current_status = 0;
    }
    if(customFeature.source && customFeature.source !== 'none'){
      param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      }
    }
    if (customFeature.form === 'goods' && customFeature.pickUpArr && compData.type == "list-vessel") {
      param.pick_up_type = [];
      if (customFeature.pickUpArr.express) {
        param.pick_up_type.push(1);
      }

      if (customFeature.pickUpArr.sameJourney) {
        param.pick_up_type.push(2);
      }

      if (customFeature.pickUpArr.selfLifting) {
        param.pick_up_type.push(3);
      }

      if (customFeature.pickUpArr.dining) {
        param.pick_up_type.push(4);
      }
    }
    param.page_size = customFeature.loadingNum || 10;

    let field = app.getListVessel(compData);
    let fieldData = {};

    param.need_column_arr = field.concat('app_id', 'id', 'is_seckill', 'mode_id', 'goods_id', 'is_group_buy','seckill_activity_id','seckill_activity_time_id','is_seckill_activity');

    fieldData['eles[' + compindex + '].listField'] = field;
    fieldData['eles[' + compindex + '].need_column_arr'] = param.need_column_arr;
    fieldData['eles[' + compindex + '].loading'] = true;
    fieldData['eles[' + compindex + '].loadingFail'] = false;
    fieldData['eles[' + compindex + '].list_data'] = [];
    fieldData['eles[' + compindex + '].param'] = param;
    fieldData['eles[' + compindex + '].is_more'] = 1;
    fieldData['eles[' + compindex + '].curpage'] = 0;
    pageInstance.setData(fieldData);

    if (app.getInvolvedFromRefreshObject(customFeature.id, "new-classify")){
      return;
    }
    
    if (customFeature.form == 'app_shop' && field.indexOf('distance') > -1 && !isPullRefresh) {
      let locationInfo = app.globalData.locationInfo;
      if (locationInfo.latitude) {
        param.extra_cond_arr = {};
        param.extra_cond_arr.latitude = locationInfo.latitude;
        param.extra_cond_arr.longitude = locationInfo.longitude;
      } else {
        app.getLatLng({
          success: function (latlng) {
            let extra_cond_arr = {};
            extra_cond_arr.latitude = latlng.latitude;
            extra_cond_arr.longitude = latlng.longitude;
            pageInstance.setData({
              ['eles[' + compindex + '].param.extra_cond_arr']: extra_cond_arr
            });
            that.init(compindex, pageInstance, true);
          },
          fail: function () {
            app.showToast({
              title: '定位失败，店铺距离将获取不到',
              icon: 'none'
            });
            that.init(compindex, pageInstance, true);
          }
        });
        return;
      }
    }

    if (customFeature.showSingleData && compData.type == "list-vessel") {
      this.requestSingleData(pageInstance, customFeature, compindex, field, param);
    } else {
      this.getReviewConfig(reviewList => {
        app.sendRequest({
          hideLoading: true,
          url: url,
          data: param,
          method: 'post',
          chain: true,
          subshop: pageInstance.franchiseeId || '',
          success: function (res) {
            if (res.status == 0) {
              let newdata = {};

              if (param.form !== 'form') {
                for (let j in res.data) {
                  if (customFeature.form == 'group_buy') {
                    res.data[j] = {
                      form_data: Object.assign({}, res.data[j])
                    }
                  }
                  for (let k in res.data[j].form_data) {
                    if (k == 'review_status') {
                      res.data[j].form_data[k] = res.data[j].form_data[k] == 0 ? reviewList.applying_text || '待审核' : res.data[j].form_data[k] == 1 ? reviewList.apply_passed_text || '审核通过' : reviewList.apply_unpassed_text || '审核不通过'
                    }
                    if (k == 'review_result') {
                      res.data[j].form_data[k] = res.data[j].form_data[k].replace(/\\n/, '');
                    }
                    if (k == 'category') {
                      continue;
                    }
                    if(/region/.test(k)){
                      continue;
                    }
                    if(k == 'goods_model') {
                      res.data[j].form_data.virtual_price = app.formVirtualPrice(res.data[j].form_data);
                    }
                    if (k == 'distance') {
                      res.data[j].form_data[k] = util.formatDistance(res.data[j].form_data[k]);
                    }
                    let description = res.data[j].form_data[k];
  
                    if (field.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) { //没有绑定的字段的富文本置为空
                      res.data[j].form_data[k] = '';
                    }
                  }
                }
              }
  
              newdata['eles[' + compindex + '].list_data'] = res.data;
              newdata['eles[' + compindex + '].is_more'] = res.is_more || 0;
              newdata['eles[' + compindex + '].curpage'] = 1;
              newdata['eles[' + compindex + '].loading'] = false;
              newdata['eles[' + compindex + '].loadingFail'] = false;
  
              pageInstance.setData(newdata);
            }
          },
          fail: function(res){
            let newdata = {};
            newdata['eles[' + compindex + '].loadingFail'] = true;
            newdata['eles[' + compindex + '].loading'] = false;
            pageInstance.setData(newdata);
          }
        });
      })
    }
  }

  getReviewConfig = (callBack) => {
    app.sendRequest({
      url: '/index.php?r=AppConfig/GetAppDataReviewTextConfig',
      method: 'post',
      hideLoading: true,
      success: res=> {
        callBack && callBack(res.data);
      }
    })
  }

  requestSingleData = (pageInstance, customFeature, compindex, field, param) => {
    this.getReviewConfig(reviewList => {
      app.sendRequest({
        url: '/index.php?r=AppData/GetDatasByUserToken',
        data: { 
          form: param.form,
          page: param.page,
          page_size: customFeature.loadingNum || 10
        },
        method: 'post',
        success: function (res) {
          if (res.status == 0) {
            let newdata = {};
            if (param.form !== 'form') {
              for (let j in res.data) {
                if (customFeature.form == 'group_buy') {
                  res.data[j] = {
                    form_data: Object.assign({}, res.data[j])
                  }
                }
                for (let k in res.data[j].form_data) {
                  if (k == 'review_status') {
                    res.data[j].form_data[k] = res.data[j].form_data[k] == 0 ? reviewList.applying_text || '待审核' : res.data[j].form_data[k] == 1 ? reviewList.apply_passed_text || '审核通过' : reviewList.apply_unpassed_text || '审核不通过'
                  }
                  if (k == 'review_result') {
                    res.data[j].form_data[k] = res.data[j].form_data[k].replace(/\\n/, '');
                  }
                  if (k == 'category') {
                    continue;
                  }
                  if (/region/.test(k)) {
                    continue;
                  }
                  if (k == 'goods_model') {
                    res.data[j].form_data.virtual_price = app.formVirtualPrice(res.data[j].form_data);
                  }
                  if (k == 'distance') {
                    res.data[j].form_data[k] = util.formatDistance(res.data[j].form_data[k]);
                  }
                  let description = res.data[j].form_data[k];

                  if (field.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) { //没有绑定的字段的富文本置为空
                    res.data[j].form_data[k] = '';
                  }
                }
              }
            }

            newdata['eles[' + compindex + '].list_data'] = res.data;
            newdata['eles[' + compindex + '].is_more'] = res.is_more || 0;
            newdata['eles[' + compindex + '].curpage'] = 1;
            newdata['eles[' + compindex + '].loading'] = false;
            newdata['eles[' + compindex + '].loadingFail'] = false;

            pageInstance.setData(newdata);
          }
        },
        fail: function (res) {
          let newdata = {};
          newdata['eles[' + compindex + '].loadingFail'] = true;
          newdata['eles[' + compindex + '].loading'] = false;
          pageInstance.setData(newdata);
        }
      })
    })
  }

  _refreshListVessel = (targetCompIndex, requestData, pageInstance, isGetLatLng) => {
    let _this = this;
    let targetCompData = pageInstance.data.eles[targetCompIndex];
    let customFeature = targetCompData.customFeature;
    requestData.page_size = customFeature.loadingNum || 10;
    let needColumnArr = targetCompData.need_column_arr || [];
    let newdata = {};
    newdata['eles[' + targetCompIndex + '].loading'] = true;
    newdata['eles[' + targetCompIndex + '].loadingFail'] = false;
    newdata['eles[' + targetCompIndex + '].list_data'] = [];
    newdata['eles[' + targetCompIndex + '].is_more'] = 1;
    pageInstance.setData(newdata);
    if (needColumnArr.length) { // 优化请求速度
      requestData.need_column_arr = needColumnArr;
    } else if (requestData.page == 1){
      needColumnArr = app.getListVessel(targetCompData);
      needColumnArr = needColumnArr.concat('app_id', 'id', 'is_seckill', 'mode_id', 'goods_id', 'is_group_buy', 'seckill_activity_id', 'seckill_activity_time_id', 'is_seckill_activity');
      requestData.need_column_arr = needColumnArr;
    }
    requestData.form = customFeature.form;
    
    if (customFeature.form == 'app_shop' && needColumnArr.indexOf('distance') > -1 && !isGetLatLng) {
      app.getLatLng({
        success: function(latlng){
          requestData.extra_cond_arr = {};
          requestData.extra_cond_arr.latitude = latlng.latitude;
          requestData.extra_cond_arr.longitude = latlng.longitude;
          _this._refreshListVessel(targetCompIndex, requestData, pageInstance, true);
        },
        fail: function(){
          app.showToast({
            title: '定位失败，店铺距离将获取不到',
            icon: 'none'
          });
          _this._refreshListVessel(targetCompIndex, requestData, pageInstance, true);
        }
      })
      return;
    }

    app.sendRequest({
      url: '/index.php?r=AppData/getFormDataList',
      method: 'post',
      data: requestData,
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '', // TODO
      success: function (res) {
        let newData = {};
        let listField = pageInstance.data.eles[targetCompIndex].listField;
        for (let j in res.data) {
          for (let k in res.data[j].form_data) {
            if (k == 'category') {
              continue;
            }
            if (/region/.test(k)) {
              continue;
            }
            if (k == 'goods_model') {
              res.data[j].form_data.virtual_price = app.formVirtualPrice(res.data[j].form_data);
            }
            if (k == 'distance') {
              res.data[j].form_data[k] = util.formatDistance(res.data[j].form_data[k]);
            }
            let description = res.data[j].form_data[k];
            if (listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) { //没有绑定的字段的富文本置为空
              res.data[j].form_data[k] = '';
            } else if (app.needParseRichText(description)) {
              res.data[j].form_data[k] = app.getWxParseResult(description);
            }
          }
        }
        newData['eles[' + targetCompIndex + '].list_data'] = res.data;
        newData['eles[' + targetCompIndex + '].is_more'] = res.is_more;
        newData['eles[' + targetCompIndex + '].curpage'] = 1;
        newData['eles[' + targetCompIndex + '].scrollTop'] = 0;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        newData['eles[' + targetCompIndex + '].loadingFail'] = false;
        pageInstance.setData(newData);
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + targetCompIndex + '].loadingFail'] = true;
        newdata['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    })
  }

  pageScrollFunc = (event) => {
    app.pageScrollFunc(event)
  }

  listVesselTurnToPage = (event) => {
    app.listVesselTurnToPage(event)
  }

  render(){
    /**
     * 传入数据
     */
    const data = this.props.data;
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    if (customFeature.vesselAutoheight == 0) {
      styleObj['height'] = transformPx2Rem(customFeature['height'], 320);
    }
    /**
     * 组件内容处理
     */  
    const content = data.content;

    const hor = data.customFeature.mode == 2 && data.curpage > 0;
    /**
     * 返回组件
     */ 
    return (
      <ScrollView
        className={`custom-component list-vessel ${data.customFeature.mode? 'mode-' + data.customFeature.mode: ''} ${hor ? 'hor-request-status' : ''}`} style={styleObj}
        style={styleObj}
        data-type="list-vessel"
        data-compindex={this.props.index}
        scroll-y={(data.customFeature.mode == 2 || data.customFeature.vesselAutoheight != 0) ? false : true}
        scroll-x={data.customFeature.mode == 2 ? true: false}
        lower-threshold="100"
        bindscrolltolower={this.pageScrollFunc}
        // bindanimationend="animationEnd"
        >
        {data.list_data && data.list_data.map((item, index) => (
          <div className="list-vessel-item" key={index}
            onClick={this.listVesselTurnToPage}
            data-compindex={this.props.index}
            data-index={index}
            data-dataid={customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : (item.id || item.form_data.id)}
            data-router={customFeature.link}
            data-isseckill={(item.form_data.is_seckill && item.form_data.is_seckill) || ''}
            >
            {content.map((componentData, componentIndex) => 
              <CustomComponent key={componentIndex} index={componentIndex} data={componentData} dynamicData={item['form_data']}/>
            )}
          </div>
        ))}
        {/* 加载loading */}
        {
          data.loading && 
          <RequestStatus is="requestLoading" hor={hor}></RequestStatus>
        }
        {/* 加载没有数据 */}
        {
          data.is_more == 0 && data.list_data.length == 0 &&
          <RequestStatus is="requestNone" data={{ data: '暂无数据~'}} hor={hor}></RequestStatus>
        }
        {/* 加载失败 */}
        {
          data.loadingFail &&
          <RequestStatus is="requestFail" data={{refreshEvent: 'pageScrollFunc', compindex: this.props.index}} hor={hor}></RequestStatus>
        }
        {/* 加载完所有数据 */}
        {
          data.is_more == 0 && data.list_data.length > 0 && customFeature.isShowFinishText &&
          <RequestStatus is="requestAll" hor={hor}></RequestStatus>
        }
        {/* 点击加载按钮 */}
        {
          !!(customFeature.vesselAutoheight == 1 && customFeature.loadingMethod == 1 && customFeature.mode != 2 && data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail) &&
          <LoadingBtn customFeature={customFeature} onClick={this.pageScrollFunc} data-compindex={this.props.index}></LoadingBtn>
        }
      </ScrollView>
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/list-vessel-custom-component/ListVesselCustomComponent.jsx